"use client";

import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

export default function GlobalNetworkSection() {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-deep-dark relative overflow-hidden" ref={ref}>
      {/* Background gradient - Deeper navy base with deep purple accents */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "linear-gradient(180deg, #0A0A12 0%, #12121F 100%)",
        }}
      />
      {/* Faint global tech grid overlay */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-5"
        style={{
          backgroundImage: `
            linear-gradient(rgba(85, 48, 230, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(85, 48, 230, 0.3) 1px, transparent 1px)
          `,
          backgroundSize: "50px 50px",
          animation: "shimmer 8s ease-in-out infinite"
        }}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <motion.div 
          className="text-center mb-10 sm:mb-12 lg:mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-glass-white border border-glass-border text-xs sm:text-sm font-medium text-text-secondary backdrop-blur-xl mb-3 sm:mb-4">
            Global Infrastructure
          </span>
          <h2 
            className="font-heading font-extrabold text-text-primary px-4"
            style={{ fontSize: "clamp(28px, 5vw, 52px)", letterSpacing: "-0.015em" }}
          >
            Global Fulfilment Network
          </h2>
          <p className="text-base sm:text-lg text-text-secondary mt-3 sm:mt-4 max-w-2xl mx-auto px-4">
            Enterprise logistics infrastructure. From Shenzhen to the world.
          </p>
        </motion.div>

        {/* Stats Cards - Responsive grid */}
        <motion.div 
          className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4, staggerChildren: 0.1 }}
        >
          {[
            { label: "Countries Served", value: "90+" },
            { label: "Avg. Delivery Time", value: "5-8 days" },
            { label: "Monthly Orders", value: "50K+" },
            { label: "Warehouse Space", value: "15K m²" },
          ]?.map((stat, index) => (
            <motion.div
              key={stat?.label}
              className="glass-card rounded-2xl sm:rounded-3xl p-4 sm:p-6 text-center border border-glass-border backdrop-blur-xl"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
            >
              <div className="text-2xl sm:text-3xl lg:text-4xl font-extrabold font-heading text-accent-primary mb-1 sm:mb-2">
                {stat?.value}
              </div>
              <div className="text-xs sm:text-sm text-text-secondary font-medium">
                {stat?.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}